import { render } from "./EditLicenseModal.vue?vue&type=template&id=05f65686"
import script from "./EditLicenseModal.vue?vue&type=script&lang=js"
export * from "./EditLicenseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__